import { GenericDeleteDialog } from "@/components/ui/generic-delete-dialog";
import { TipoProduto } from "@/types/tipo-produto";

interface TipoProdutoDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  produto: TipoProduto | null;
}

export function TipoProdutoDeleteDialog({
  open,
  onOpenChange,
  onConfirm,
  produto,
}: TipoProdutoDeleteDialogProps) {
  return (
    <GenericDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      item={produto}
      onConfirm={onConfirm}
      entityName="Produto"
      getItemLabel={(p) => p.nome}
    />
  );
}
